//React
import React, { useEffect, useRef, useState } from "react";
//Components
import { Screen } from "components";
//Styles
import "./styles.scss";
const Demo = () => {
  //useEffect
  useEffect(() => {
    window.open(
      "https://wa.me/917948221313?text=Hi%20Tanmay%2C%20I%20want%20to%20know%20more%20about%20*WhatsApp%20Login*",
      "_self"
    );
  }, []);

  //Return UI
  return <Screen className="help-screen pd-20"></Screen>;
};

export default Demo;
